import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Descriptions as AntdDescriptions } from 'antd';

const DescriptionsWrapper = styled(AntdDescriptions)`
  margin-bottom: 16px;

  .ant-descriptions-header {
    padding: 16px 0px 0px 16px;
    margin-bottom: 0;
  }

  .ant-descriptions-view {
    box-shadow: rgb(0 0 0 / 5%) 0px 1px 4px 0px;
    background-color: rgb(255, 255, 255);
    padding: 8px 16px;
  }

  .ant-descriptions-title {
    color: #656668;
    font-size: 14px;
    font-weight: 800;
  }
`;

function Descriptions({ children, title, column }) {
  const labelStyle = {
    color: '#a3a4a5',
    fontSize: '12px',
    height: '16px',
  };

  const contentStyle = { fontWeight: 800 };

  return (
    <DescriptionsWrapper
      size="small"
      colon={false}
      title={title}
      layout="vertical"
      contentStyle={contentStyle}
      labelStyle={labelStyle}
      column={column}
    >
      {children}
    </DescriptionsWrapper>
  );
}

Descriptions.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
  column: PropTypes.shape({
    xxl: PropTypes.number,
    xl: PropTypes.number,
    lg: PropTypes.number,
    md: PropTypes.number,
    sm: PropTypes.number,
    xs: PropTypes.number,
  }),
};

Descriptions.defaultProps = {
  title: null,
  column: {
    xxl: 4,
    xl: 4,
    lg: 4,
    md: 3,
    sm: 3,
    xs: 2,
  },
};

/**
 * Tratamento feito para evitar o warning:
 * warning: React.jsx: type is invalid -- expected a string (for built-in components)
 * or a class/function (for composite components) but got: undefined
 *
 * Talvez não esteja identificando que o styled herda as mesmas propriedades do componente
 */
Descriptions.Item = AntdDescriptions.Item;
export default Descriptions;
